import { render, staticRenderFns } from "./MotivoVisitaRoute.vue?vue&type=template&id=22415f47"
import script from "./MotivoVisitaRoute.vue?vue&type=script&lang=js"
export * from "./MotivoVisitaRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports